import React from "react";
import overviewImage from "./assets/overview-600x400.jpg";
import productsImage from "./assets/products-600x400.jpg";
import patientAssistanceImage from "./assets/patient-assistance-program-600x400.jpg";
import clinicalTrialsImage from "./assets/clinical-trials-600x400.jpg";
import adverseEventsImage from "./assets/report-adverse-events-600x400.jpg";
import { getCookie } from "../../helpers/CookieHandler";

import { Link } from "react-router-dom";
class HomeContentPatient extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      userCountry: getCookie("welcomeCountryCode")
  }
  }
  scrollAdverseSection = () => {
    const section = document.querySelector("#adverseEventSection");
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  render() {
    const { languageContent } = this.props;
    
    return (
      <div className="container patient-home-container">
        <OverviewSection
          languageContent={languageContent}
          scrollAdverseSection={this.scrollAdverseSection}
          selectedUserCountry={this.state.userCountry}
        />
        <ProductsSection languageContent={languageContent} selectedUserCountry={this.state.userCountry} />
        {this.state.userCountry !== "DE" && (
          <PatientAssistanceSection languageContent={languageContent} selectedUserCountry={this.state.userCountry} />
        )}
        <ClinicalTrialsSection languageContent={languageContent} selectedUserCountry={this.state.userCountry} />
        <AdverseEventsSection languageContent={languageContent} selectedUserCountry={this.state.userCountry} />
      </div>
    );
  }
}
const OverviewSection = ({ languageContent, scrollAdverseSection, selectedUserCountry }) => (
  <div>
    {selectedUserCountry !== "DE" && (
      <div className="row mb-5">
        <div className="col-md-5 col-lg-4">
          <img
            src={overviewImage}
            alt="A doctor advising a patient"
            className="image"
          />
        </div>
        <div className="col-md-7 col-lg-8">
          <div className="pl-md-2">
            <h5 className="header-primary mt-1">
              {languageContent.aboutUsHeader}
            </h5>
            <ul className="subtitle">
              <li>{languageContent.learnOrAskQuestions}</li>

              <li>{languageContent.findHelp}</li>

              <li>
                <a
                  role="button"
                  className="adverse-link"
                  onClick={scrollAdverseSection}
                >
                  {languageContent.adverseEventLink}
                </a>
                {languageContent.reportProblems}
              </li>
              <li>
                {languageContent.learnMoreMI}
                <Link
                  className="anchor-link"
                  to="/about-us"
                  data-tag="track-link"
                  data-analytics-text={`Homepage Overview - ${languageContent.aboutUs}`}
                >
                  {languageContent.here}
                </Link>
              </li>
              <li>
                {languageContent.learnMoreAbbvie}
                <a
                  className="anchor-link"
                  href={languageContent.learnMoreLink} // added Key-value instead of link
                  target="_blank"
                  rel="noopener noreferrer"
                  data-tag="track-exit"
                >
                  {languageContent.here}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row-separator" />
      </div>
    )}
    {selectedUserCountry === "DE" && (
      <div className="row mb-5">
        <div className="col-md-5 col-lg-4">
          <img
            src={overviewImage}
            alt="A doctor advising a patient"
            className="image"
          />
        </div>
        <div className="col-md-7 col-lg-8">
          <div className="pl-md-2">
            <h5 className="header-primary mt-1">
              {languageContent.aboutUsHeader}
            </h5>
            <ul className="subtitle">
              <li>{languageContent.learnOrAskQuestions}</li>

              <li>{languageContent.findHelp}</li>
              <li>
                {languageContent.learnMoreMI}
                <Link
                  className="anchor-link"
                  to="/about-us"
                  data-tag="track-link"
                  data-analytics-text={`Homepage Overview - ${languageContent.aboutUs}`}
                >
                  {languageContent.here}
                </Link>
              </li>
              <li>
                {languageContent.learnMoreAbbvie}
                <a
                  className="anchor-link"
                  href={languageContent.learnMoreLink} // added Key-value instead of link
                  target="_blank"
                  rel="noopener noreferrer"
                  data-tag="track-exit"
                >
                  {languageContent.here}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row-separator" />
      </div>
    )}
  </div>
);

// TODO: hide this section if they don't have product permissions
const ProductsSection = ({ languageContent, selectedUserCountry }) => (
  <div>
    {selectedUserCountry !== "DE" && (
      <div className="row mb-5">
        <div className="col-md-5 col-lg-4">
          <img
            src={productsImage}
            alt="A patient reading a product label"
            className="image"
          />
        </div>
        <div className="col-md-7 col-lg-8">
          <div className="pl-md-2">
            <h5 className="header-primary mt-1">
              {languageContent.productsHeader}
            </h5>
            <p className="subtitle">{languageContent.productsSubHeader}</p>
            <Link
              to="/products"
              className="btn btn-info btn-lg-wide btn-rounded"
              data-tag="track-link"
              data-analytics-text={`${languageContent.productsHeader} - ${languageContent.browseProducts}`}
            >
              {languageContent.browseProducts}
            </Link>
          </div>
        </div>
        <div className="row-separator" />
      </div>
    )}
    {selectedUserCountry === "DE" && (
      <div className="row mb-5">
        <div className="col-md-5 col-lg-4">
          <img
            src={productsImage}
            alt="A patient reading a product label"
            className="image"
          />
        </div>
        <div className="col-md-7 col-lg-8">
          <div className="pl-md-2">
            <h5 className="header-primary mt-1">
              {languageContent.productsHeader}
            </h5>
            <p className="subtitle">{languageContent.productsSubHeader}</p>
            <a
              href={languageContent.germanyProducts}
              target= "_blank"
              className="btn btn-info btn-lg-wide btn-rounded"
              data-tag="track-link"
              data-analytics-text={`${languageContent.productsHeader} - ${languageContent.browseProducts}`}
            >
              {languageContent.browseProducts}
            </a>
          </div>
        </div>
        <div className="row-separator" />
      </div>
    )}
  </div>
);

const PatientAssistanceSection = ({ languageContent, selectedUserCountry }) => (
  <div className="row mb-5">
    <div className="col-md-5 col-lg-4">
      <img
        src={patientAssistanceImage}
        alt="A pharmacist at work"
        className="image"
      />
    </div>
    <div className="col-md-7 col-lg-8">
      <div className="pl-md-2">
        <h5 className="header-primary mt-1">
          {languageContent.patientAssistanceHeader}
        </h5>
        <p className="subtitle">
          {languageContent.patientAssistanceSubHeader}{" "}
          {languageContent.patientAssistanceContact}{" "}
          <a href="tel:+18002226885" className="phone-link">
            1-800-222-6885
          </a>{" "}
          {languageContent.orClickBelow}
        </p>
        {selectedUserCountry !== "DE" && (
          <a
            href={languageContent.contactOnlineLink} // added Key value instead of link
            className="btn btn-info btn-lg-wide btn-rounded"
            target="_blank"
            rel="noopener noreferrer"
            data-tag="track-exit"
            data-analytics-text={`${languageContent.patientAssistanceHeader} - ${languageContent.contactOnline}`}
          >
            {languageContent.contactOnline}
          </a>
        )}
        {selectedUserCountry === "DE" && (
          <a
            href={languageContent.contactOnlineLink} // added Key value instead of link
            className="btn btn-info btn-lg-wide btn-rounded"
            target="_blank"
            rel="noopener noreferrer"
            data-tag="track-exit"
            data-analytics-text={`${languageContent.patientAssistanceHeader} - ${languageContent.contactOnline}`}
          >
            {languageContent.contactOnline}
          </a>
        )}
      </div>
    </div>
    <div className="row-separator" />
  </div>
);

const ClinicalTrialsSection = ({ languageContent, selectedUserCountry }) => (
  <div className="row mb-5">
    <div className="col-md-5 col-lg-4">
      <img
        src={clinicalTrialsImage}
        alt="A medical researcher presenting results"
        className="image"
      />
    </div>
    <div className="col-md-7 col-lg-8">
      <div className="pl-md-2">
        <h5 className="header-primary mt-1">
          {languageContent.clinicalTrialsHeader}
        </h5>
        <p className="subtitle">{languageContent.clinicalTrialsSubHeader}</p>

        <a
          href={languageContent.clinicalTrialsForPatientsLink} // added Key value instead of link
          className="btn btn-info btn-lg-wide btn-rounded aligned-button-pair"
          target="_blank"
          rel="noopener noreferrer"
          data-tag="track-exit"
          data-analytics-text={`${languageContent.clinicalTrialsHeader} - ${languageContent.clinicalTrialsForPatients}`}
        >
          {languageContent.clinicalTrialsForPatients}
        </a>
        <br className="button-spacer" />
        {selectedUserCountry !== "DE" && (
          <a
            href={languageContent.clinicalTrialsForCaregiversLink} // added Key value instead of link
            className="btn btn-primary btn-outline hover btn-lg-wide btn-rounded aligned-button-pair"
            target="_blank"
            rel="noopener noreferrer"
            data-tag="track-exit"
            data-analytics-text={`${languageContent.clinicalTrialsHeader} - ${languageContent.clinicalTrialsForCaregivers}`}
          >
            {languageContent.clinicalTrialsForCaregivers}
          </a>
        )}
      </div>
    </div>
    <div className="row-separator" />
  </div>
);

const AdverseEventsSection = ({ languageContent, selectedUserCountry }) => (
  <div id="adverseEventSection" className="row mb-5">
    <div className="col-md-5 col-lg-4">
      <img
        src={adverseEventsImage}
        alt="A man using a laptop"
        className="image"
      />
    </div>
    <div className="col-md-7 col-lg-8">
      <div className="pl-md-2">
        <h5 className="header-primary mt-1">
          {languageContent.adverseEventsHeader}
        </h5>
        <p className="subtitle">{languageContent.productIssuesConcerns}</p>
        <ul className="subtitle">
          <li>
            {languageContent.An} <strong>{languageContent.adverseEvent}</strong>
            {languageContent.adverseEventDefinition}
          </li>
          <li>
            {languageContent.A}
            <strong>{languageContent.productQuality}</strong>
            {languageContent.productQualityDefinition}
          </li>
          <li className="indented">{languageContent.isBroken}</li>
          <li className="indented">{languageContent.isNotWorking}</li>
          <li className="indented">{languageContent.mayBeUnsafe}</li>
        </ul>
        {selectedUserCountry !== "DE" && (
          <p className="subtitle">
            {languageContent.reportAnAdverseEventCall}{" "}
            <a href="tel:8446633742" className="phone-link">
              844-663-3742
            </a>
            {languageContent.FDAContact}{" "}
            <a href="tel:+18003321088" className="phone-link">
              1-800-FDA-1088 <wbr />
              (1-800-332-1088)
            </a>{" "}
            {languageContent.orClickingBelow}
          </p>
        )}
        {selectedUserCountry === "DE" && (
          <p className="subtitle">
            {languageContent.reportAnAdverseEventCall}{" "}
            <a href="mailto:ams@abbvie.com">ams@abbvie.com.</a>
            {languageContent.FDAContact}{" "}
            <a href="mailto:QA-affiliate-GER@abbvie.com">
              QA-affiliate-GER@abbvie.com.
            </a>
            {languageContent.orClickingBelow}
          </p>
        )}

        {selectedUserCountry !== "DE" && (
          <a
            href={languageContent.visitFDAWebsiteLink} // added Key value instead of link
            className="btn btn-info btn-lg-wide btn-rounded"
            target="_blank"
            rel="noopener noreferrer"
            data-tag="track-exit"
            data-analytics-text={`${languageContent.adverseEventsHeader} - ${languageContent.visitFDAWebsite}`}
          >
            {languageContent.visitFDAWebsite}
          </a>
        )}
      </div>
    </div>
  </div>
);

export default HomeContentPatient;



// WEBPACK FOOTER //
// ./src/mi-app/home/HomeContentPatient.js